import { FileViewerStage } from "./FileViewerStage";
import { useFileViewerFile } from "./hooks/useFileViewerFile";

export interface FilePreviewByIdProps {
  fileId: string;
}

export const FilePreviewById = ({ fileId }: FilePreviewByIdProps) => {
  const view = useFileViewerFile(fileId);
  return <FileViewerStage view={view} />;
};
